import { Row, Col, Image } from 'antd';
import { config } from '../../../config';
import { useTranslation, withTranslation } from 'react-i18next';
import React from 'react';
import { ResponsiveContainer, Typography } from '@sunday/component';
import styles from './home-generalInsurance.module.scss';
import generalInsuranceData from './home-generalInsurance.json';

const { ASSET_PREFIX } = config;
const HomePageGeneralInsuranceNameSpace = ['component.home.generalInsurance'];

export const HomeGeneralInsurance = () => {
const { t } = useTranslation(HomePageGeneralInsuranceNameSpace);
  return (
    <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
      <ResponsiveContainer className={styles.container}>
        <Row justify="center">
          <Col xl={6} sm={6} xs={0}>
            <Typography.Display designLevel={3} weight='bold' className={styles.title} >
              {t('title')}
            </Typography.Display>
            <Typography.Title designLevel={3} >
              {t('body')}
            </Typography.Title>
          </Col>
          <Col xl={0} xs={24}>
            <Typography.Headline designLevel={1} weight='bold' className={styles.title} >
              {t('title')}
            </Typography.Headline>
            <Typography.Body designLevel={1} >
              {t('body')}
            </Typography.Body>
          </Col>
          <Col xl={18} xs={0} >
            <Row justify={"center"}>
              {generalInsuranceData.map((item: any, index: number) => (
                <Col key={`general-insurance-${index+1}`} className={styles.insurances}>
                  <Image
                    preview={false}
                    alt={item.altImg}
                    src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                    style={{ marginBottom: "40px", width: "160px" }}
                  />
                  <Typography.Headline designLevel={2} weight='bold'>
                    {t(`generalInsurances.item-${index+1}.title`)}
                  </Typography.Headline>
                  <Typography.Body designLevel={2} >
                  {t(`generalInsurances.item-${index+1}.body`)}
                  </Typography.Body>
                </Col>
              ))}
              {
                (generalInsuranceData.length %2 === 1) && (
                  <Col key={`general-insurance-`} className={styles.insurancesFiller}>
                  </Col>
                )
              }
            </Row>
          </Col>
          <Col xl={0} xs={18} >
            <Row justify={"center"}>
              {generalInsuranceData.map((item: any, index: number) => (
                <Col key={`general-insurance-${index+1}`} className={styles.insurances}>
                  <Image
                    preview={false}
                    alt={item.altImg}
                    src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                    style={{ marginBottom: "40px" }}
                  />
                  <Typography.Headline designLevel={3} weight='bold'>
                    {t(`generalInsurances.item-${index+1}.title`)}
                  </Typography.Headline>
                  <Typography.Body designLevel={3} >
                  {t(`generalInsurances.item-${index+1}.body`)}
                  </Typography.Body>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </ResponsiveContainer>
    </div>
  );
};

export default withTranslation('page.home')(HomeGeneralInsurance);
